import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {InformationSriInterface} from "../../services/interface/sri/information-sri-interface";
import {ItemHeader, ItemInfo, ItemInfoSpouse} from "../components/ViewData";
import {Collapse} from "@material-tailwind/react";
import {formatDateString} from "../../utils/daysOptions";
import {useNavigate, useParams} from "react-router";
import CustomButton from "../../components/general/CustomButton";
import {Person} from "../../services/interface/query/person";
import * as Icons from "@mui/icons-material";
import {useTaxPayerStorage} from "../../services/storage/TaxPayerStorage";
import NotPermissionComponent from "../dashboard/NotPermissionComponent";
import * as IconsMui from "@mui/icons-material";
import InfoOnline from "../components/InfoOnline";
import IdentificationConsult from "../terms-conditions/IdentificationConsult";

interface Props {
    openCollapse?: boolean;
    setOpenCollapse?: React.Dispatch<React.SetStateAction<boolean>>;
    viewCollapse?: boolean;
    movePage?: boolean;
    personNatural?: Person;

    getTaxPayer: any;
    successTaxPayer: any;
    loadingTaxPayer: boolean;
    errorTaxPayer: any;
}

export default function BasicInformationSri({
                                                openCollapse,
                                                setOpenCollapse,
                                                viewCollapse,
                                                movePage,
                                                personNatural,
                                                errorTaxPayer,
                                                loadingTaxPayer,
                                                successTaxPayer,
                                                getTaxPayer
                                            }: Props) {
    const {ruc} = useParams();
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const data = useTaxPayerStorage(data => data.data)
    const setData = useTaxPayerStorage(data => data.setData)

    const [information, setInformation] = useState<InformationSriInterface | undefined>()
    const styleIcon = 'min-w-[20px] min-h-[20px]'
    const history = useNavigate();

    useEffect(() => {
        if (ruc) {
            getTaxPayer({identifier: `${ruc}`, msj: t('ruc')})
        }
    }, [ruc]);

    useEffect(() => {
        if (personNatural && personNatural.identification) {
            getTaxPayer({identifier: `${personNatural.identification}001`, msj: t('ruc')})
        }
    }, [personNatural]);

    useEffect(() => {
        if (successTaxPayer) {
            setData(successTaxPayer)
        }
    }, [successTaxPayer]);

    useEffect(() => {
        if (data) {
            setInformation(data)
        }
    }, [data]);

    useEffect(() => {
        if (errorTaxPayer) {
            setInformation(undefined)
            setData(undefined)
        }
    }, [errorTaxPayer]);

    const toggleOpen = () => {
        if (setOpenCollapse) setOpenCollapse((cur) => !cur)
    };

    function TaxAgentComponent() {
        return (
            <AlertComponent
                label={t('tax-agent-alert')}
                icon={<GetCheck check={information?.taxAgent}/>}
            />
        )
    }

    function Obligated() {
        return (
            <AlertComponent
                label={t('obligated')}
                icon={
                    <GetCheck
                        check={information?.obligated}
                    />
                }
            />
        )
    }

    function SpecialTaxpayer() {
        return (
            <AlertComponent
                label={t('specialTaxpayer')}
                icon={
                    <GetCheck
                        check={information?.specialTaxpayer}
                    />
                }
            />
        )
    }

    // function WhiteListed() {
    //     return (
    //         <AlertComponent
    //             label={t('whiteListed')}
    //             icon={<GetCheck check={information?.whiteListed}/>}
    //         />
    //     )
    // }

    function PhantomTaxpayer() {
        return (
            <AlertComponent
                label={t('phantomTaxpayer')}
                icon={<GetCheck check={information?.phantomTaxpayer}
                                dangerAlert={true}/>}
            />
        )
    }

    function TaxpayerNonexistentTransactions() {
        return (
            <AlertComponent
                label={t('taxpayerNonexistentTransactions')}
                icon={<GetCheck check={information?.taxpayerNonexistentTransactions}
                                dangerAlert={true}/>}
            />
        )
    }

    function OverdueObligation() {
        return (
            <AlertComponent
                label={t('overdueObligation')}
                icon={
                    <GetCheck
                        check={information?.overdueObligation}
                        dangerAlert={true}
                    />
                }
            />
        )
    }

    // function TaxComponent() {
    //     return (
    //         <AlertComponent label={t('tax-return-alert')} icon={<GetCheck check=nformation?.taxReturnAlert)}>/>}
    //     )
    // }
    //
    // function PatentComponent() {
    //     return (
    //         <AlertComponent label={t('patent-payment-alert')} icon={<GetCheck check=nformation?.patentPaymentAlert)}>/>}
    //     )
    // }

    function AlertComponent({label, icon, className}: { label: string, icon: React.ReactNode, className?: string }) {
        return (
            <div
                className={`${className} bg-header w-full rounded-[5px] p-0 text-white grid 
                grid-cols-5 items-center justify-center text-center gap-2`}>
                <div className={'col-span-4 text-[15px] px-1 py-2'}>{label}</div>
                <div
                    className={'bg-white !border border-header h-full rounded-r-[5px] justify-center items-center flex'}>{icon}</div>
            </div>
        )
    }

    function GetCheck({check, dangerAlert}: { check?: boolean | null, dangerAlert?: boolean }) {
        if (check) {
            if (dangerAlert) {
                return <IconsMui.SentimentDissatisfiedTwoTone className={'text-danger'}/>
            }
            return <div className={'text-empColorSecondary text-[14px] uppercase'}>{t('Si')}</div>
        } else {
            if (dangerAlert && check !== undefined && check !== null) {
                return <IconsMui.EmojiEmotionsTwoTone className={'text-success'}/>
            }
            return <div className={'text-empColorSecondary text-[14px] uppercase'}>{check === undefined || check === null ? '-' : t('No')}</div>
        }
    }

    return (
        <NotPermissionComponent
            title={'/tax_payer/basicData'}
            loading={loadingTaxPayer}
            error={errorTaxPayer}
            component={
                <div className={'custom-card bg-white w-full px-4 py-4'}>
                    <div
                        className={`flex flex-col sm:flex-row w-full gap-3 items-center ${!viewCollapse ? 'pb-2' : ''}`}>
                        {viewCollapse &&
                            <img
                                src={'/assets/images/grupo.png'}
                                className={'cursor-pointer hover:bg-gray-200 rounded-[10px] p-1'}
                                onClick={toggleOpen}
                                width={55}
                                height={55}
                                alt={'info-basic'}/>
                        }
                        {!movePage &&
                            <div className={'flex flex-col'}>
                                <span className={'font-bold'}>{t('client')}</span>
                                <h3>{information?.tradeName ? information.tradeName : information?.businessName ? information?.businessName : !loadingTaxPayer ? t('not-register') : ''}</h3>
                            </div>
                        }
                        <div className={'sm:ml-auto flex flex-col sm:flex-row gap-4'}>
                            <ItemHeader text={information?.taxIdentificationNumber}
                                        icon={<Icons.FingerprintTwoTone className={'text-header'}/>}/>
                            <ItemHeader text={information?.legalEntityTypeDescription}
                                        icon={<Icons.PortraitTwoTone className={'text-header'}/>}/>
                            <InfoOnline
                                onClick={() => {
                                    if (data?.taxIdentificationNumber || data?.accountant) {
                                        getTaxPayer({
                                            identifier: `${data?.taxIdentificationNumber ? data.taxIdentificationNumber : data?.accountant}`,
                                            msj: t('ruc')
                                        })
                                    } else if (personNatural && personNatural.identification) {
                                        getTaxPayer({identifier: `${personNatural.identification}001`, msj: t('ruc')})
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <Collapse open={openCollapse === undefined ? true : openCollapse}>
                        <div
                            className={`${!movePage ? 'flex flex-col sm:flex-row' : 'flex flex-col sm:flex-row'} border border-t-1 border-t-header border-transparent pt-4 gap-2 overflow-x-auto`}>
                            <div
                                className={`${!movePage ? 'w-full sm:w-[75%] flex flex-col' : 'flex flex-col w-full'} gap-3`}>
                                <div className={'grid grid-cols-1 md:grid-cols-4 gap-3'}>
                                    <ItemInfo
                                        className={`${!movePage ? 'col-span-3' : 'col-span-2'}`}
                                        label={t('businessName')}
                                        text={information?.businessName}
                                        icon={<Icons.BusinessTwoTone
                                            className={styleIcon}/>}
                                        loading={loadingTaxPayer}
                                    />
                                    <ItemInfo
                                        label={t('legal-situation')}
                                        text={information?.naturalPersonStatus}
                                        icon={<Icons.PolicyTwoTone className={styleIcon}/>}
                                        loading={loadingTaxPayer}
                                    />
                                </div>
                                {!movePage &&
                                    <>
                                        <div className={'grid grid-cols-1 md:grid-cols-3 gap-3 border border-t-1 border-t-secondary border-transparent pt-2'}>
                                            <ItemInfoSpouse label={t('taxpayerRegime')}
                                                            text={information?.taxpayerRegime}
                                                            loading={loadingTaxPayer}
                                            />
                                            <ItemInfoSpouse label={t('tax-payer-class')}
                                                            text={information?.taxpayerClass}
                                                            loading={loadingTaxPayer}
                                            />
                                            <ItemInfoSpouse label={t('fileNumber')}
                                                            text={information?.fileNumber}
                                                            loading={loadingTaxPayer}
                                            />
                                        </div>
                                        <div className={'grid grid-cols-1 md:grid-cols-3 gap-3'}>
                                            <ItemInfoSpouse label={t('registrationDateRuc')}
                                                            text={formatDateString(information?.registrationDateRuc)}
                                                            icon={<Icons.TodayTwoTone
                                                                className={styleIcon}/>} loading={loadingTaxPayer}/>
                                            <ItemInfoSpouse label={t('constitutionDate')}
                                                            icon={<Icons.TodayTwoTone
                                                                className={styleIcon}/>}
                                                            text={information?.constitutionDate}
                                                            loading={loadingTaxPayer}
                                            />
                                            <ItemInfoSpouse label={t('appointmentDate')}
                                                            icon={<Icons.TodayTwoTone
                                                                className={styleIcon}/>}
                                                            text={information?.appointmentDate}
                                                            loading={loadingTaxPayer}
                                            />
                                        </div>
                                    </>
                                }
                                <div className={`${!movePage ? 'grid grid-cols-1 md:grid-cols-4' : 'grid grid-cols-1 md:grid-cols-2'} gap-3 border border-t-1 border-t-secondary border-transparent pt-2`}>
                                    <ItemInfo label={t('start-activities-date')}
                                              text={formatDateString(information?.startActivitiesDate)}
                                              icon={<Icons.TodayTwoTone
                                                  className={styleIcon}/>} loading={loadingTaxPayer}/>
                                    <ItemInfo label={t('updateDate')}
                                              icon={<Icons.TodayTwoTone
                                                  className={styleIcon}/>}
                                              text={information?.updateDate}
                                              loading={loadingTaxPayer}
                                    />
                                    <ItemInfo label={t('suspensionDate')}
                                              icon={<Icons.TodayTwoTone
                                                  className={styleIcon}/>}
                                              text={information?.suspensionDate}
                                              loading={loadingTaxPayer}
                                    />
                                    <ItemInfo label={t('restartActivitiesDate')}
                                              icon={<Icons.TodayTwoTone
                                                  className={styleIcon}/>}
                                              text={information?.restartActivitiesDate}
                                              loading={loadingTaxPayer}
                                    />
                                </div>
                                <div className={`${!movePage ? 'grid grid-cols-1 md:grid-cols-2' : 'grid grid-cols-1 md:grid-cols-2'} gap-3 border border-t-1 border-t-secondary border-transparent pt-2`}>
                                    <ItemInfoSpouse label={t('legalRepresentativeIdentification')}
                                              icon={<Icons.FingerprintTwoTone
                                                  className={styleIcon}/>}
                                              text={<IdentificationConsult identification={information?.legalRepresentativeIdentification ?? '-'}/>}
                                              loading={loadingTaxPayer}
                                    />
                                    <ItemInfoSpouse label={t('legalRepresentativeName')}
                                              icon={<Icons.PortraitTwoTone
                                                  className={styleIcon}/>}
                                              text={information?.legalRepresentativeName ?? '-'}
                                              loading={loadingTaxPayer}
                                    />
                                </div>
                            </div>
                            <div
                                className={`${!movePage ? 'w-full sm:w-[25%] flex flex-col' : 'w-full grid lg:grid-cols-2 gap-6'} items-center my-auto`}>
                                <div className={'flex flex-col gap-2 w-full'}>
                                    <OverdueObligation/>
                                    <PhantomTaxpayer/>
                                    <TaxpayerNonexistentTransactions/>
                                </div>
                                <div
                                    className={`${!movePage ? 'border border-t-1 border-t-header border-transparent pt-2 mt-2' : 'mt-2'} w-full flex flex-col gap-2`}>
                                    <TaxAgentComponent/>
                                    <Obligated/>
                                    <SpecialTaxpayer/>
                                </div>
                                {/*<PatentComponent/>*/}
                            </div>
                        </div>
                        {movePage &&
                            <div className={'flex flex-col gap-3 lg:flex-row mt-3'}>
                                <CustomButton
                                    className={'bg-empColorSecondary'}
                                    icon={<Icons.Search className={`${styleIcon}`}/>}
                                    text={t('move-sri')}
                                    disabled={!information}
                                    onClick={() => {
                                        history(`/dashboard-ruc/${information?.taxIdentificationNumber}`)
                                    }}
                                />
                                {/*<ItemNumber*/}
                                {/*    className={'ml-auto max-h-[35px] min-h-[35px] max-w-[280px] min-w-[250px] mt-auto'}*/}
                                {/*    label={t('value-deductible')}*/}
                                {/*    loading={loadingTaxPayer}*/}
                                {/*    value={`$${information?.valueDeductible ? information?.valueDeductible : '0'}`}/>*/}
                            </div>
                        }

                    </Collapse>
                </div>
            }
        />
    );
}
